import React, { useEffect } from 'react';
import { CATEGORY_LABELS } from '../utils/aiReview';

const btnApprove = 'px-4 min-h-[44px] rounded-card bg-selo text-white text-sm font-semibold hover:bg-selo-dark transition-colors';
const btnReject = 'px-4 min-h-[44px] rounded-card border border-line text-sm font-semibold text-ink hover:border-navy transition-colors';

function Suggestion({ item, onApprove, onReject }) {
  const observation = item.tipo === 'observacao';
  if (item.status === 'approved') {
    return <li className="rounded-card border border-selo/25 bg-selo-tint px-4 py-3 text-sm text-selo font-semibold">Aplicada: {CATEGORY_LABELS[item.categoria]}</li>;
  }
  return (
    <li className="rounded-card border border-line bg-paper p-4">
      <p className="text-xs font-semibold text-muted uppercase tracking-wide mb-2">{CATEGORY_LABELS[item.categoria]}</p>
      {observation ? (
        <p className="text-sm text-ink break-words">{item.motivo}</p>
      ) : (
        <>
          <div className="text-sm break-words space-y-1">
            <p className="text-muted line-through">{item.original}</p>
            <p className="text-ink font-medium"><span aria-hidden="true">→ </span>{item.sugerido}</p>
          </div>
          <p className="text-sm text-muted mt-2">{item.motivo}</p>
        </>
      )}
      {item.flags?.includes('acrescenta_conteudo') && (
        <p className="text-xs font-semibold text-danger bg-danger-tint rounded px-2 py-1 mt-2">Acrescenta termo ausente no laudo</p>
      )}
      {item.status === 'notfound' ? (
        <p className="text-sm font-semibold text-danger mt-3">Trecho não encontrado</p>
      ) : (
        <div className="flex flex-wrap gap-2 mt-3">
          {!observation && <button type="button" onClick={() => onApprove(item)} className={btnApprove}>Aprovar</button>}
          <button type="button" onClick={() => onReject(item)} className={btnReject}>{observation ? 'Dispensar' : 'Reprovar'}</button>
        </div>
      )}
    </li>
  );
}

export default function AIReviewModal({ state, error, items, quota, onApprove, onReject, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const visible = items.filter((i) => i.status !== 'dismissed');
  const allHandled = state === 'done' && items.length > 0 && visible.length === 0;

  return (
    <div className="fixed inset-0 bg-navy/50 backdrop-blur-[2px] z-[200] flex items-end sm:items-center justify-center sm:p-4" role="dialog" aria-modal="true" aria-label="Revisar com IA">
      <div className="bg-paper w-full sm:max-w-xl max-h-[90vh] flex flex-col rounded-t-card sm:rounded-card shadow-xl border border-line">
        <div className="flex justify-between items-center gap-3 p-5 border-b border-line">
          <h2 className="font-display text-xl font-bold text-navy tracking-tight">Revisar com IA</h2>
          {quota && <span className="text-xs text-muted">{Math.max(quota.limit - quota.used, 0)} de {quota.limit}</span>}
        </div>
        <div className="p-5 overflow-y-auto flex-1">
          {state === 'loading' && <p className="text-sm text-muted py-8 text-center" role="status">Revisando o laudo…</p>}
          {state === 'error' && <p className="text-sm text-danger bg-danger-tint rounded-card p-4" role="alert">{error}</p>}
          {state === 'done' && items.length === 0 && <p className="text-sm text-muted py-8 text-center">Nenhuma sugestão.</p>}
          {allHandled && <p className="text-sm text-muted py-8 text-center">Nenhuma sugestão pendente.</p>}
          {visible.length > 0 && (
            <ul className="space-y-3">
              {visible.map((item) => <Suggestion key={item.id} item={item} onApprove={onApprove} onReject={onReject} />)}
            </ul>
          )}
        </div>
        <div className="flex justify-end p-5 border-t border-line">
          <button type="button" onClick={onClose} className={btnReject}>Fechar</button>
        </div>
      </div>
    </div>
  );
}
